<ng-template #attractLoopModal>
    <div id="attractLoopPopup" class="card attractLoopPopup" dir={{direction}}>
        <div id="attractLoopPopupTab" class="tab-div d-flex">
            <ng-container>
                <div class='tab' (click)='switchToAttractLoopTab()' 
                [ngClass]="{'active-tab':isAttractLoopActive ,'inactive-tab':!isAttractLoopActive}">
                <img  class='round' [ngClass]="{'blue_1':isAttractLoopActive ,'grey_1':!isAttractLoopActive}" alt="Circle image"><span i18n="@@attractor-loop-popup.new-attract-loop-video-label">New Attract Loop Video</span></div>
                <div class='ml-3 tab' (click)='switchtoFFTab()'
                [ngClass]="{'active-tab':!isAttractLoopActive ,'inactive-tab':isAttractLoopActive}">
                <img class='round' [ngClass]="{'grey_2':isAttractLoopActive ,'blue_2':!isAttractLoopActive}" alt="Circle image"><span i18n="@@create-promo-content.select-form-factor">Select Form Factors</span></div>
            </ng-container>
        </div>
        <form [formGroup]="attractorLoopPopupFrm" *ngIf='isAttractLoopActive; else secondTab'>
            <div id="attractLoopPopupBody" class="popup-body">
                <div id="attractLoopPopupHeader" class="attract-loop-header">
                    <div id="attractLoopPopupClose" (click)="dismiss()" class="close_icon">
                    </div>
                </div>
                <div id="attractLoopModalBody" class="attract-loop-body">
                    <div id="attractLoopModalCard" class="card_desc">
                        <ul [ngClass]="isVideoSizeConstraintRemoved ? 'tooltip-list-style' : ''">
                            <li *ngIf="isVideoSizeConstraintRemoved" i18n="@@global.tooltip.video-rule-format">Video
                                must be in <strong>MP4</strong> format
                            </li>
                            <li *ngIf="!isVideoSizeConstraintRemoved">
                                <span i18n="@@attractor-loop-popup.upload-video-duration-message">Video must be in MP4
                                    format and less than 60 seconds.</span>
                            </li>
                            <li *ngIf="!isVideoSizeConstraintRemoved">
                                <span i18n="@@attractor-loop-popup.upload-video-size-message">Video must be maximum of
                                    10 MB.</span>
                            </li>
                        </ul>
                    </div>
                    <div id="uploadButton" class="attract-loop-video-div">
                        <label class="mb-0" for="uploadedVideoName">
                            <input class="form-control" id="uploadedVideoName" type="file" accept="video/mp4"
                                (change)="readVideoUrl($event)" hidden>
                            <span class="btn btn-primary btn-sm left_icon_btn upload-video-btn">
                                <span class="upload-video_icon"></span>
                                <span i18n="@@attractor-loop-popup.upload-video-label">Upload Video</span>
                                <span>*</span>
                            </span>

                        </label>
                        <div id="videoFile" class="mt-1 video-file-name" *ngIf="isVideo">{{videoFile.name}}</div>
                        <div id="videoFileError" *ngIf="fileTypeError" class="uploadfile_err_msg"><span
                                i18n="@@create-attractor-loop.videoTypeError.incorrect">Incorrect file type
                                received.</span>
                            <div id="videoToolTip">
                                <span i18n="@@global.tooltip.video-rule-format">Video must be in <strong>MP4</strong>
                                    format.</span>
                            </div>
                        </div>
                        <div id="videoLengthError" *ngIf="videoLengthError" class="uploadfile_err_msg">
                            <span i18n="@@global.content-grp.video-duration-error">Video must be <strong>less than 60
                                    seconds
                                    long.</strong></span>
                        </div>
                        <div id="videoSizeError" *ngIf="videoSizeErr">
                            <span class="attract-loop-validation-msg"
                                i18n="@@attractor-loop-popup.upload-video-size-message">Video must be maximum of 10
                                MB.</span>
                        </div>

                    </div>
                    <div id="publishSection" class="row publish-internal-section">
                        <div class="form-group col-md-6">
                            <label for="publishedName"><span i18n="@@global.tab-text.published-name">Published
                                    Name</span><span class="text-danger">*</span></label>
                            <input type="text" class="form-control" id="publishedName"
                                placeholder={{publishedNamePlaceholder}} formControlName="publishedName"
                                name="publishedName" maxlength="50" required />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="internalName"><span i18n="@@global.tab-text.internal-name">Internal
                                    Name</span></label>
                            <input type="text" class="form-control" id="internalName"
                                placeholder={{internalNamePlaceholder}} formControlName="internalName"
                                name="internalName" maxlength="50">
                        </div>
                    </div>
                    <div id="publishInternalSection" class="row publish-internal-section">
                        <div class="col-md-6">
                            <label for="publishedTimeStamp"><span i18n="@@create-segments.form-group.publish-date-time">Publishing Date
                                and Time</span></label>
                                <div id="publishDate" class="publishDate-Section">
                                    <div id="customRadio" class="custom-radio">
                                      <input type="radio" name="publishdate" id="now" class="form-check-input dateSelectionRadio" id="now" 
                                        [checked]="!isPublishDateCustomDatepicker" (click)="selectCustomPublishDate('Now')"  />
                                      <label for="now"><span i18n="@@create-segments.form-group.now">Now</span></label>
                                    </div>
                                    <div id="customDatePicker" class="custom-datepicker">
                                      <input type="radio" name="publishdate" id="publish-date-custom" class="form-check-input dateSelectionRadio"
                                        id="publish-date-custom" [checked]="isPublishDateCustomDatepicker"
                                        (click)="selectCustomPublishDate('custom')" />
                                      <label for="publish-date-custom" *ngIf="!isPublishDateCustomDatepicker"><span
                                          i18n="@@create-segments.form-group.custom">Custom</span></label>
                                      <div id="publishDateCustomDatepicker" *ngIf="isPublishDateCustomDatepicker">
                                        <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'publish')"
                                          (getDateTimeZoneData)="getLogoContentPublishDate($event)" (isTimeZoneSelected)="checkTimeZone($event,'publish')"
                                          [publishDateInfo]="editPublishDateInfo" [divideDate]="divideDateFormat" [isAttractLoop]="true">
                                        </iposcen-date-time-zone>
                                      </div>
                                    </div>
                                </div>
                                <div id="customePublishTimeZone" *ngIf="isCustomPublishDateCorrect || isCustomPublishTimeZoneSelected" class="formfield_err_msg"> 
                                    <span i18n="@@create-segments.form-group.publish-date-time-zone">Please select publishing date and time
                                      zone.</span>
                                </div>
                        </div>
                        <div id="expiry" class="col-md-6 expiry-div">
                            <label for="publishedTimeStamp"><span i18n="@@create-segments.form-group.expiry-date-time">Expiration
                                Date and Time</span></label>
                            <div id="expiryDateSection" class="publishDate-Section">
                                <div id="expiryCustomRadio" class="custom-radio">
                                    <input type="radio" name="expiryDate" id="never" class="form-check-input dateSelectionRadio" id="never"
                                      [checked]="!isExpiryDatePicker" (click)="selectExpiryDateTimeZone('Never')" />
                                    <label for="never"><span i18n="@@create-segments.form-group.never">Never</span></label>
                                </div>
                                <div id="expiryCustomDatePicker" class="custom-datepicker">
                                    <input type="radio" name="expiryDate" id="expiry-custom" class="form-check-input dateSelectionRadio" id="expiry-custom"
                                      [checked]="isExpiryDatePicker" (click)="selectExpiryDateTimeZone('custom')" />
                                    <label for="expiry-custom" *ngIf="!isExpiryDatePicker"><span
                                        i18n="@@create-segments.form-group.custom">Custom</span></label>
                                    <div id="expiryDatePicker" *ngIf="isExpiryDatePicker">
                                      <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'expiry')"
                                        (getDateTimeZoneData)="getLogoContentExpiryDate($event)" (isTimeZoneSelected)="checkTimeZone($event,'expiry')" 
                                        [expiryDateInfo]="editexpiryDateInfo" [divideDate]="divideDateFormat" [isAttractLoop]="true">
                                      </iposcen-date-time-zone>
                                    </div>
                                </div>
                                <div id="expiredDateIncorrectError" *ngIf="isExpiredDateIncorrect" class="formfield_err_msg errMsg">
                                    <span i18n="@@create-segments.form-group.less-than-publish-date">Expiration date should not be before publishing date.</span>
                                </div>
                                <div id="expiryDateCorrectError" *ngIf="isCustomExpiryDateCorrect || isCustomExpiryTimeZoneSelected" class="formfield_err_msg errMsg"><span
                                    i18n="@@create-segments.form-group.expiry-date-time-zone">Please select expiration date and time
                                    zone.</span>
                                </div>
                            </div>
                        </div>
                    
                    </div>
                </div>
                <div id="attractLoopPopupFooter" class="modal-footer new-attract-loop-popup-footer">
                    <button type="button" (click)="dismiss()" class="btn btn-outline-primary gtmCancelDltContGrp">
                        <span i18n="@@attractor-loop-popup.cancel-message">Cancel</span>
                    </button>
                    <button type="button" (click)="selectFormFactors()" class="btn btn-primary gtmDeleteContGrp">
                        <span i18n="@@create-promo-content.select-form-factor">Select Form Factors</span>
                    </button>
                </div>
            </div>
        </form>
        <!-- Form-factor slections Tab -->
        <ng-template #secondTab>
            <div id="secondTabBody" class="popup-body" >
                <div id="secondTabHeader" class="attract-loop-header"><div (click)="dismiss()" class="close_icon"></div>
                </div>
                <div id="secondTabBody" class="attract-loop-body">
                    <div id="formFactorTitle" class="mb-3 mt-1 form-factor-title"><span i18n="@@form-factors.body.all-columns-shown-below-are-required">All columns shown below are required.</span></div>
                    <div id="formFactorTable" class="form_factor_table">
                        <div id="formFactorColumn" class="form_factor_column">
                           <form [formGroup]="formDeviceTypes">
                              <div id="factorType" class="factor_type">{{deviceTypesHeader}}</div>
                              <div class="form-group mt-2 mb-4">
                                 <input type="checkbox" [checked]="isAllDevicetypesChecked"
                                    (change)="onSelectAllFormFactorsChange($event, 'Device Types')" id="selectAllDeviceTypes" />
                                 <label for="selectAllDeviceTypes" [innerHTML]="selectAll"></label>
                              </div>
                              <div id="factorCheck" class="factor_check form-group" formArrayName="deviceTypes"
                                 *ngFor="let order of deviceTypesArray.controls; let i = index">
                                 <input type="checkbox" [formControlName]="i" />
                                 <label for="i">{{formFactorsJSONData.deviceTypes[i].name}}</label>
                              </div>
                           </form>
                        </div>
                        <!-- Manufacturers -->
                        <div id="manufacturesFormFactorColumn" class="form_factor_column">
                           <form [formGroup]="formManufacturers">
                              <div id="manufacturesFactorType" class="factor_type">{{manufacturersHeader}}</div>
                              <div id="manufacturesFactorCheckbox" class="form-group mt-2 mb-4">
                                 <input type="checkbox" [checked]="isAllManufacturersChecked"
                                    (change)="onSelectAllFormFactorsChange($event, 'Manufacturers')" id="selectAllManufac" />
                                 <label for="selectAllManufac" [innerHTML]="selectAll"></label>
                              </div>
                              <div id="manufacturesFactorCheck" class="factor_check form-group" formArrayName="manufacturers"
                                 *ngFor="let order of manufacturersArray.controls; let i = index">
                                 <input type="checkbox" [formControlName]="i" />
                                 <label for="i">{{formFactorsJSONData.manufacturers[i].name}}</label>
                              </div>
                           </form>
                        </div>
                        <!-- Processors -->
                        <div id="processorsFormfactorColumn" class="form_factor_column">
                           <form [formGroup]="formProcessors">
                              <div id="processorsFactorType" class="factor_type">{{processorsHeader}}</div>
                              <div id="processorsCheckbox" class="form-group mt-2 mb-4">
                                 <input type="checkbox" [checked]="isAllProcessorsChecked"
                                    (change)="onSelectAllFormFactorsChange($event, 'Processors')" id="selectAllProc" [disabled]="selectAllProcDisabled"/>
                                 <label for="selectAllProc" [innerHTML]="selectAll"></label>
                              </div>
                              <div id="ProcessorsFactorCheck" class="factor_check form-group" formArrayName="processors"
                                 *ngFor="let order of processorsArray.controls; let i = index">
                                 <input type="checkbox" [formControlName]="i" />
                                 <label for="i">{{formFactorsJSONData.processors[i].name}}</label>
                              </div>
                           </form>
                        </div>
                        <!-- Generations -->
                        <div id="generationsFormFactorColumn" class="form_factor_column">
                           <form [formGroup]="formGenerations">
                              <div id="generationsFactorType" class="factor_type">{{generationsHeader}}</div>
                              <div id="generationsCheckbox" class="form-group mt-2 mb-4">
                                 <input type="checkbox" [checked]="isAllGenerationsChecked"
                                    (change)="onSelectAllFormFactorsChange($event, 'Generations')" id="selectAllGens" />
                                 <label for="selectAllGens" [innerHTML]="selectAll"></label>
                              </div>
                              <div id="generationsFactorCheck" class="factor_check form-group" formArrayName="generations"
                                 *ngFor="let order of generationsArray.controls; let i = index">
                                 <input type="checkbox" [formControlName]="i" />
                                 <label for="i">{{formFactorsJSONData.generation[i].name}}</label>
                              </div>
                           </form>
                        </div>
                     </div>
                </div>
                <div id="newAttractLoopPopupFooter" class="modal-footer new-attract-loop-popup-footer">
                    <div id="ErrorMsg" *ngIf="isSelectionMade" class="color-red error-message">
                        <img src="assets/images/icon_exclamation_circle.svg" alt="exclamation" />
                        <span class='error-message-padding' *ngIf="errorColumns.length === 1"
                           i18n="@@form-factors.footer.error.column-can-not-empty">{{errorColumns[0]}} column can’t be empty</span>
                        <span class='error-message-padding' *ngIf="errorColumns.length === 2"
                           i18n="@@form-factors.footer.error.columns-can-not-empty">{{errorColumns[0]}} and {{errorColumns[1]}}
                           columns can’t be empty</span>
                        <span class='error-message-padding' *ngIf="errorColumns.length === 3"
                           i18n="@@form-factors.footer.error.two-columns-can-not-empty">{{errorColumns[0]}}, {{errorColumns[1]}} and
                           {{errorColumns[2]}} columns can’t be empty</span>
                        <span class='error-message-padding' *ngIf="errorColumns.length === 4"
                           i18n="@@form-factors.footer.three-columns-can-not-empty">{{errorColumns[0]}}, {{errorColumns[1]}},
                           {{errorColumns[2]}} and {{errorColumns[3]}} columns can’t be empty</span>
                     </div>
                    <button type="button" (click)="dismiss()" class="btn btn-outline-primary gtmCancelDltContGrp">
                        <span i18n="@@attractor-loop-popup.cancel-message">Cancel</span>
                    </button>
                    <button type="button" (click)="saveAttractLoopVideo()" class="btn btn-primary gtmDeleteContGrp"
                    [disabled]="!isFormValid">
                        <span> {{saveSelectionText}} </span>
                    </button>
                </div>
            </div>
        
        </ng-template>
    </div>
</ng-template>